import React from 'react';
import { Bar, Link } from './Styles';


const Navbar = () => {
  return(
    <Bar>
      <Link to='/'>Pokédex</Link>
    </Bar>
  );
}

export default Navbar;